<template>
  <div class="btn-group">
    <button class="btn btn-primary mb-2 align-items-center" @click="createPage">
      <i class="icon icon-plus mr-1 typo-icon-10"></i>
      {{ $t("agency.addShop") }}
    </button>
  </div>
</template>

<script>
export default {
  name: "ButtonAddShop",
  props: {
    label: String,
    type: String
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    createPage() {
      this.$emit("openAddShopModal");
    }
  }
};
</script>

<style lang="scss" scoped>
.btn{
  padding: 11px 24px 12px 24px;
}
// .btn-create {
//   @include trans-all;
//   display: inline-flex;
//   ::v-deep .btn-create-dropdown {
//     width: 400px;
//     right: 0;
//     padding: 0;
//     border-radius: 10px !important;
//     box-shadow: 0px 15px 30px rgba(0, 24, 46, 0.2);

//     .btn-create-item {
//       padding: 32px;
//       display: flex;

//       svg {
//         fill: $grey2;
//       }

//       &:hover {
//         @include trans-all;
//         svg {
//           fill: $cPrimary;
//         }
//         .text-content {
//           p:last-child {
//             color: $black1;
//           }
//         }
//       }

//       &:last-child {
//         padding-top: 16px;
//       }

//       .text-content {
//         flex: 1;
//         p:not(:last-child) {
//           margin-bottom: 4px;
//         }
//       }
//     }
//   }
// }
</style>
